<!--采购订单列表 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="addNew(3)" v-if="permission.addOrder"
                    >{{ permission.addOrder }} (F1)</el-button
                >
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询 (F2)</el-button>
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="add(3)" v-if="permission.add">{{ permission.add }} (F3)</el-button>
                <el-button size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()" v-if="permission.print && !isDefaultSet">{{
                    permission.print
                }}</el-button>
                <el-button v-if="permission.printPreview && !isDefaultSet" size="small" icon="el-icon-view" class="search-btn btn-primary" @click="printPreview()">{{
                    permission.printPreview
                }}</el-button>
                <el-button v-if="permission.printPreviewH" size="small" icon="el-icon-view" class="search-btn btn-primary" @click="printPreview(true)">{{
                    permission.printPreviewH
                }}</el-button>
                <el-button
                    v-if="(permission.printPreview || permission.print) && isDefaultSet"
                    size="small"
                    icon="el-icon-printer"
                    class="search-btn btn-primary"
                    @click="printPreview()"
                    >打印</el-button
                >
                <el-button size="small" icon="el-icon-download" class="search-btn btn-primary" @click="exportForm" v-if="permission.export">{{
                    permission.export
                }}</el-button>
                <el-button v-if="permission.importOrder" size="small" class="search-btn btn-primary" @click="gotoImportPage">
                    <i class="fa fa-file-excel-o"></i>
                    {{ permission.importOrder }}
                </el-button>
                <el-button v-if="permission.importCreateOrder" size="small" class="search-btn btn-primary" @click="gotoImportCreatePage">
                    <i class="fa fa-file-excel-o"></i>
                    {{ permission.importCreateOrder }}
                </el-button>
                <el-button size="small" icon="el-icon-document" class="search-btn btn-primary" @click="history()" v-if="permission.history">{{
                    permission.history
                }}</el-button>
                <el-button size="small" icon="el-icon-document" class="search-btn btn-primary" @click="planDetail()" v-if="permission.planPurDetail">{{
                    permission.planPurDetail
                }}</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearch()" v-if="permission.searchAP">{{ permission.searchAP }}</el-button>
                <el-button v-if="permission.total" size="small" icon="el-icon-s-data" class="search-btn btn-primary" @click="showCount">{{ permission.total }}</el-button>
                <el-upload
                    :action="upLoadUrl2"
                    :headers="headers"
                    :on-error="uploadErr"
                    accept=".xls, .xlsx"
                    :show-file-list="false"
                    :before-upload="beforeUpload"
                    :on-success="uploadSuccess"
                    v-loading.fullscreen.lock="upLoading"
                    v-if="permission.importJCOrder"
                    style="margin: 0 10px"
                >
                    <el-button size="small" icon="fa fa-file-excel-o" class="search-btn" type="warning"> {{ permission.importJCOrder }}</el-button>
                </el-upload>
                <el-button v-if="permission.printBatch" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="printBatch()">{{
                    permission.printBatch
                }}</el-button>
                <el-button v-if="permission.finishCallback" size="small" type="danger" class="search-btn" @click="finishCallBack()">结单</el-button>
            </div>
            <div class="search-ctn-right" v-if="summaryStr">
                <div class="section-summary">
                    <div>
                        <span>{{ summaryStr }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-ctn sales-order-table">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                border=""
                style="width: 100%"
                :tableCode="tableCode"
                @cell-dblclick="handleDBClick"
                @sort-change="sortChange"
                :row-key="getRowKeys"
                v-loading="loading"
                :summary-method="getSummaries"
                show-summary
            >
                <el-table-column type="selection" reserve-selection width="50"></el-table-column>
                <template v-for="(col, index) in columnShowSets">
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        v-if="col.ColumnCode == 'OrderCode'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <img src="@/assets/images/union.png" title="联盟订单" style="width: 20px; height: 20px" v-if="scope.row.IsUnionOrder" />
                            <img src="@/assets/images/agent.png" title="联盟代发对账单" style="width: 20px; height: 20px" v-if="scope.row.IsAgentOrder" />
                            <el-badge :value="'打印' + scope.row.PrintedCount + '次'" class="mark" type="danger" v-if="scope.row.PrintedCount > 0">{{
                                scope.row.OrderCode
                            }}</el-badge>
                            {{ scope.row.PrintedCount > 0 ? '' : scope.row.OrderCode }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else-if="col.ColumnCode == 'PaymentStateName'"
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.PaymentStateName == '已付款'" class="pay-active">{{ scope.row.PaymentStateName }}</i>
                            <i v-else>{{ scope.row.PaymentStateName }}</i>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else-if="col.ColumnCode == 'WarehouseName'"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.WarehouseName }}
                            <span style="color: #8492a6" v-if="scope.row.WarehouseType == 1">(前置仓)</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else-if="col.ColumnCode == 'InWarehouseStateName'"
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.InWarehouseStateName == '已入仓'" class="in-active">{{ scope.row.InWarehouseStateName }}</i>
                            <i v-else>{{ scope.row.InWarehouseStateName }}</i>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else
                    >
                    </el-table-column>
                </template>
                <el-table-column fixed="right" label="操作" :autoWidth="true" :isCanSet="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button
                                v-if="permission.edit && scope.row.IsCanUpdate && !scope.row.IsAgentOrder"
                                title="编辑"
                                size="mini"
                                type="text"
                                @click="add(2, scope.row)"
                                >编辑</el-button
                            >
                            <el-button
                                v-if="permission.editOrder && scope.row.IsCanUpdate && !scope.row.IsAgentOrder"
                                title="编辑"
                                size="mini"
                                type="text"
                                @click="addNew(2, scope.row)"
                                >{{ permission.editOrder }}</el-button
                            >
                            <el-button
                                v-if="permission.submit && scope.row.IsCanSubmit && !scope.row.IsAgentOrder"
                                title="提交"
                                size="mini"
                                type="text"
                                @click="submitOrder(scope.row)"
                                >{{ permission.submit }}</el-button
                            >
                            <el-button
                                v-if="(permission.modify && scope.row.IsCanModify && !scope.row.IsAgentOrder) || (priceCanBeEdit ? scope.row.IsCanPay : false)"
                                title="修改采购单"
                                size="mini"
                                type="text"
                                @click="add(7, scope.row)"
                                >{{ permission.modify }}</el-button
                            >
                            <el-button
                                v-if="(permission.modifieOrder && scope.row.IsCanModify && !scope.row.IsAgentOrder) || (priceCanBeEdit ? scope.row.IsCanPay : false)"
                                title="修改订单"
                                size="mini"
                                type="text"
                                @click="addNew(7, scope.row)"
                                >{{ permission.modifieOrder }}</el-button
                            >
                            <el-button v-if="permission.pay && scope.row.IsCanPay" :title="permission.pay" size="mini" type="text" @click="add(5, scope.row)">{{
                                permission.pay
                            }}</el-button>
                            <el-button v-if="permission.afterSale && scope.row.IsCanReturn" title="采购退货" size="mini" type="text" @click="returns(scope.row)">{{
                                permission.afterSale
                            }}</el-button>
                            <el-button
                                v-if="permission.shareCost && !scope.row.IsCanSubmit && scope.row.IsCanPay"
                                title="成本分摊"
                                size="mini"
                                type="text"
                                style="color: orange"
                                @click="shareCost(scope.row)"
                                >{{ permission.shareCost }}</el-button
                            >
                            <el-button v-if="permission.askAgain" title="再次询价" size="mini" type="text" @click="BJAgain(scope.row)">{{
                                permission.askAgain
                            }}</el-button>
                            <el-button
                                v-if="permission.transSOrder && scope.row.IsCanTransToSale"
                                :title="permission.transSOrder"
                                size="mini"
                                type="text"
                                @click="gotoSOrder(scope.row)"
                                >{{ permission.transSOrder }}</el-button
                            >
                            <el-button
                                v-if="permission.transSOrderHK && scope.row.IsCanTransToSale"
                                :title="permission.transSOrderHK"
                                size="mini"
                                type="text"
                                @click="gotoSOrderHK(scope.row)"
                                >{{ permission.transSOrderHK }}</el-button
                            >
                            <el-button
                                v-if="!scope.row.IsLock && permission.isLock && scope.row.IsCanSubmit"
                                title="锁定后不能被合并进来该采购单"
                                style="color: orange"
                                size="mini"
                                type="text"
                                @click="addCombineLock(scope.row)"
                                >{{ permission.isLock }}</el-button
                            >
                            <el-button
                                style="color: red"
                                v-else-if="scope.row.IsLock && scope.row.IsCanSubmit"
                                title="取消锁定"
                                size="mini"
                                type="text"
                                @click="cancleCombineLock(scope.row)"
                                >取消锁定</el-button
                            >
                            <!-- <el-button
                                v-if="permission.addToInten && scope.row.IsCanSubmit && !scope.row.IsTranInten"
                                title="并入在订"
                                style="color: orange"
                                size="mini"
                                type="text"
                                @click="addToInten(scope.row)"
                                >{{ permission.addToInten }}</el-button
                            >
                            <el-button  style="color: red" v-else-if="scope.row.IsTranInten && scope.row.IsCanSubmit" title="取消并入在订" size="mini" type="text" @click="cancleToInten(scope.row)"
                                >取消并入在订</el-button
                            > -->
                            <el-button
                                v-if="permission.cancel && scope.row.IsCanCancel && !scope.row.IsAgentOrder"
                                title="取消"
                                size="mini"
                                type="text"
                                style="color: orange"
                                @click="cancel(scope.row)"
                                >{{ permission.cancel }}</el-button
                            >
                            <el-button v-if="permission.del && scope.row.IsCanDelete" size="mini" type="text" style="color: red" @click="del(scope.row)">{{
                                permission.del
                            }}</el-button>
                            <el-button
                                v-if="permission.callback && (scope.row.InWarehouseStateName == '已入仓' || scope.row.InWarehouseStateName == '部分入仓')"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="callbackData(scope.row)"
                                >{{ permission.callback }}</el-button
                            >
                            <el-button v-if="permission.opRecords" title="操作记录" size="mini" type="text" @click="opRecords(scope.row)">{{
                                permission.opRecords
                            }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="dialogVisible" width="860px">
            <div class="dialog-content" v-if="dialogVisible">
                <printPurContent @closeDialog="closeDialog" :printIds="idList" :canPrint="canPrint" :isInit="true"></printPurContent>
            </div>
        </el-dialog>
        <!-- 打印隐藏内容，用于直接打印 -->
        <div style="visibility: hidden; width: 870px; position: absolute !important; top: -1000px !important" id="printDom" v-if="isRegister">
            <printPurContent ref="printDom" @closeDialog="closeDialog" :printIds="idList" :canPrint="true" :isInit="false"></printPurContent>
        </div>
        <!-- 打印采购汇总表 -->
        <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="dialogPOsVisible" width="860px">
            <div class="dialog-content" v-if="dialogPOsVisible">
                <printHKPurOrdersBatch
                    @closeDialog="
                        () => {
                            dialogPOsVisible = false;
                        }
                    "
                    :ordersList="multipleSelection"
                    :isDefaultSet="isDefaultSet"
                    :isInit="true"
                    :isPreview="isPreview"
                ></printHKPurOrdersBatch>
            </div>
        </el-dialog>
        <!--   搜索配件    -->
        <el-dialog :close-on-click-modal="false" title="搜索配件" :visible.sync="searchVisible" width="1200px">
            <div v-if="searchVisible">
                <searchAP canEdit="canNot" @closeDialog="closeSearchDialog"></searchAP>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="合计" @close="closeStatisticsDialog" :visible.sync="statisticsVisible" width="500px">
            <div class="dialog-content" v-if="statisticsVisible">
                <statistics :countData="multipleSelection" type="buy"></statistics>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="采购单的操作记录" :visible.sync="OrderLifesVisible" width="1000px">
            <div class="dialog-content" v-if="OrderLifesVisible">
                <ordersLifes :OrderId="OrderId" :OrderType="1" @closeDialog="closeOrderLifesDialog"></ordersLifes>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="采购订单搜索"
            :visible.sync="dialogSearchVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-order-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogSearchVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="供应商">
                        <el-select
                            ref="search_sup"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.Keyword"
                            remote
                            filterable
                            clearable
                            allow-create
                            placeholder="请输入供应商名称"
                            :remote-method="searchSupplier"
                            v-select-scroll-more="searchSupplierLoad"
                        >
                            <el-option v-for="item in supplierOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="采购单号">
                        <el-input
                            style="width: 100%"
                            size="small"
                            v-model.trim="searchData.OrderCode"
                            v-filter-special-char="searchData.OrderCode"
                            placeholder="采购单号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="入库仓库" v-if="isExObj('WarehouseName')">
                        <el-select size="small" style="width: 100%" v-model="searchData.WarehouseId" filterable clearable @visible-change="wHVisibleChange($event)">
                            <el-option
                                v-for="optionItem in warehouseList"
                                :key="optionItem.WarehouseId"
                                :label="optionItem.WarehouseName"
                                :value="optionItem.WarehouseId"
                            >
                                <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单状态" v-if="isExObj('StateName')">
                        <el-select style="width: 100%" size="small" v-model="searchData.State">
                            <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="支付方式" v-if="isExObj('PayTypeName')">
                        <el-select style="width: 100%" size="small" v-model="searchData.PayType" @visible-change="payVisibleChange($event)">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开单部门" v-if="isExObj('OrgName')">
                        <el-select
                            size="small"
                            class="search-item"
                            style="width: 100%"
                            v-model="searchData.OrgId"
                            filterable
                            clearable
                            collapse-tags
                            reserve-keyword
                            @visible-change="orgVisibleChange($event)"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="optionItem in orgSearchData"
                                :key="optionItem.Id"
                                :data-msg="optionItem"
                                :label="optionItem.Name"
                                :value="optionItem.Id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="采购员" v-if="isExObj('SName')">
                        <el-select
                            v-model="searchData.SId"
                            style="width: 100%"
                            filterable
                            clearable
                            remote
                            size="small"
                            placeholder="请选择"
                            @visible-change="siVisibleChange($event)"
                        >
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单来源" v-if="isExObj('CusSourcesName') && isUseSource">
                        <el-select style="width: 100%" size="small" v-model="searchData.CusSources" clearable @visible-change="cusSourceVisibleChange($event)">
                            <el-option v-for="item in cusSourceList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建日期" v-if="isExObj('CreateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="dateTimes1"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate1TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="更新日期" v-if="isExObj('UpdateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="dateTimes2"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate2TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="提交日期" v-if="isExObj('ConfirmTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="dateTimes3"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate3TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="入库日期" v-if="isExObj('WHFinishTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="dateTimes4"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate4TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog_N">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import statistics from '@/components/common/statistics';
import Vue from 'vue';
import mixin from '@/mixins/mixin';
import searchAP from '@/components/common/searchAP';
import breadcrumb from '@/components/common/breadcrumb';
import ordersLifes from '@/components/common/ordersLifes';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        searchAP,
        statistics,
        breadcrumb,
        elTableColumn,
        ordersLifes
    },
    data() {
        return {
            isStopReq: false,
            loading: false,
            summaryStr: '',
            dateTimes1: [],
            dateTimes2: [],
            dateTimes3: [],
            dateTimes4: [],
            orgSearchData: [],
            cusSourceList: [],
            tableCode: 'PurchaseOrderTable',
            statisticsVisible: false,
            multipleSelection: null,
            searchVisible: false,
            idList: [],
            canPrint: true, ////为了应对海口的未提交也可以预览的需求
            dialogType: '-1',
            editData: {},
            dialogVisible: false,
            dialogPOsVisible: false, //是否显示汇总打印
            OrderId: '',
            OrderLifesVisible: false,
            searchData: {
                Keyword: '',
                State: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                CStartDate: '',
                CEndDate: '',
                WStartDate: '',
                WEndDate: '',
                SortProp: '',
                SortType: '',
                WarehouseId: '',
                OrgId: '',
                CusSources: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            payWayList: [],
            SIdList: [],
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未提交', Value: '0' },
                { Text: '未付款', Value: '5' },
                { Text: '已付款', Value: '10' },
                { Text: '未入仓', Value: '15' },
                { Text: '已入仓', Value: '20' },
                { Text: '已完成', Value: '30' },
                { Text: '已取消', Value: '25' }
            ],
            columnShowSets: [],
            // 用于供应商列表，分页搜索
            supplierOptions: [],
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            isPreview: false,
            isDefaultSet: true,
            isStartSearch: false,
            dialogSearchVisible: false,
            isUseSource: false, //是否启用采购开单显示来源
            warehouseList: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            isRegister: false,
            priceCanBeEdit: false,
            upLoading: false,
            upLoadUrl2: '/api/EntpPurchaseOrder/UploadJCPurOrderExcel',
            headers: {
                'access-key': this.$util.getLocalStorage('userMsg').Token,
                reqApp: 'yqgPC'
            }
        };
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_sup.focus();
                });
            }
        }
    },
    activated() {
        document.addEventListener('keydown', this.handleKeyEvent);
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            if (this.$store.state.orderData && this.$store.state.orderData.Id) {
                this.getSingleData(this.$store.state.orderData, true);
            }
        }
        //切换页面的时候不会清除当前页面缓存，但是其他页面也有相同字段，会串页面数据，还是把数据清空了不要误导
        this.$refs.multipleTable.clearSelection();
        this.idList = [];
        this.multipleSelection = null;
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogSearchVisible) this.dialogSearchVisible = false;
        next();
    },
    created() {
        if (this.tableCode) this.getSetsData();
        this.getConfigByCodes();
    },
    mounted() {
        let that = this;
        that.permission = that.$util.getPermission('supplierBuyOrder');
        //加载组件
        that.getPrintComponents();
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            if (that.statisticsVisible || that.searchVisible || that.OrderLifesVisible || that.dialogVisible || that.dialogPOsVisible) return;
            let key = window.event.keyCode;
            //F1
            if (key === 112) {
                e.preventDefault();
                that.addNew(3);
            }
            //F2
            if (key === 113) {
                e.preventDefault();
                if (that.SIdList.length <= 1) that.getSIdList();
                that.dialogSearchVisible = true;
                that.isStartSearch = true;
            }
            //F3
            if (key === 114) {
                e.preventDefault();
                that.add(3);
            }
            if (key === 13) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.handleSearch();
                    that.isStartSearch = false;
                }
            }
            if (key === 27) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.dialogSearchVisible = false;
                    that.isStartSearch = false;
                }
            }
            //右键
            if (key === 39) {
                e.preventDefault();
                if (!this.dialogSearchVisible) {
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);

                    if (page < totalPages) {
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                }
                return;
            }
            //左键
            if (key === 37) {
                e.preventDefault();
                if (!that.dialogSearchVisible) {
                    if (that.searchData.page !== 1) {
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                }
                return;
            }
        },
        getConfigByCodes() {
            let that = this;
            let codes = ['syllqdysz', 'dyyl', 'djmrdtsj', 'xgcgjg', 'cgddly'];
            let isDefaultToday = false;
            that.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'syllqdysz':
                                that.isDefaultSet = result;
                                break;
                            case 'dyyl': //是否出现预览界面
                                that.isPreview = result;
                                break;
                            case 'djmrdtsj':
                                isDefaultToday = result;
                                break;
                            case 'xgcgjg': //未完成前价格是否可以修改
                                that.priceCanBeEdit = result;
                                break;
                            case 'cgddly': //是否启用采购开单显示来源
                                that.isUseSource = result;
                                break;
                        }
                    }
                    if (isDefaultToday && that.isExObj('CreateTime')) {
                        //当前设定的日期时间
                        let d = new Date();
                        let year1, month1, day1;
                        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
                        let date1 = new Date(year1, month1, day1, 0);
                        that.dateTimes1.push(date1);

                        //前一天设定的日期时间
                        let year2, month2, day2;
                        d.setTime(d.getTime());
                        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
                        let date2 = new Date(year2, month2, day2, 0);
                        that.dateTimes1.unshift(date2);

                        that.searchData.StartDate = date2;
                        that.searchData.EndDate = date1;
                    }
                }
                that.getTableData();
            });
        },
        getPrintComponents() {
            let that = this;
            that.$util.getPrintComponents(1).then(data => {
                if (data) {
                    Vue.component('printPurContent', () => import('@/components/printModels/' + data));
                    that.isRegister = true;
                } else {
                    Vue.component('printPurContent', () => import('@/components/printModels/printPurchases'));
                    that.isRegister = true;
                }

                if (that.permission.printBatch) {
                    Vue.component('printHKPurOrdersBatch', () => import('@/components/printModels/printHKPurOrdersBatch'));
                }
            });
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.EntpCusPOId;
        },
        // 供应商列表，搜索
        async searchSupplier(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.supplierOptions = [];
            }
            if (this.supplierForm.stopLoad) return;
            const data = await this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit);
            if (data) {
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.supplierOptions = [...this.supplierOptions, ...data];
            }
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchSupplier();
        },
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        getSIdList() {
            this.$util.getPurchaserList().then(data => {
                this.SIdList = data;
            });
        },
        // 显示统计
        showCount() {
            if (this.multipleSelection) {
                this.statisticsVisible = true;
            } else {
                this.$util.warningMsg('请至少选择一条数据');
            }
        },
        closeStatisticsDialog() {
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = null;
            this.statisticsVisible = false;
        },
        showSearch() {
            this.searchVisible = true;
        },
        closeSearchDialog() {
            this.searchVisible = false;
        },
        returns(row) {
            //传的是采购单Id
            this.$router.push(`/purchaseManage/purchasesReturns/edit_v2?type=0&id=${row.EntpCusPOId}`);
        },
        // 提交订单
        submitOrder(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要提交该采购单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpPurchaseOrder/SubmitEntpPurOrder',
                            data: {
                                EntpCusPOId: row.EntpCusPOId
                            }
                        })
                        .then(() => {
                            that.$util.successMsg('提交成功');
                            that.getSingleData({ Id: row.EntpCusPOId, IsAdd: false }, false);
                        });
                }
            });
        },
        // 再次询价
        BJAgain(row) {
            this.$router.push(`/purchaseManage/purchaseOrders/transToInquirySheet?type=4&id=${row.EntpCusPOId}`);
        },
        //转销售单
        gotoSOrder(row) {
            this.$router.push(`/salesManage/salesOrder/edit_v2?type=9&pid=${row.EntpCusPOId}`);
        },
        //转销售单
        gotoSOrderHK(row) {
            this.$router.push(`/salesManage/salesOrder/edit_v3?type=9&pid=${row.EntpCusPOId}`);
        },
        shareCost(row) {
            this.$router.push(`/purchaseManage/purchaseOrders/shareCost?id=${row.EntpCusPOId}`);
        },
        // 导出
        exportForm() {
            if (!this.idList[0]) {
                this.$util.warningMsg('请至少选择一条数据导出');
                return;
            }
            let EntpCusPOIds = this.idList.map(item => item.id).join(',');
            this.$util.exportFile({
                url: '/api/EntpPurchaseOrder/ExportEntpPurOrder',
                data: {
                    EntpCusPOIds: EntpCusPOIds
                }
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push({
                    id: val[i].EntpCusPOId,
                    orderCode: val[i].OrderCode
                });
            }
            this.idList = idList;
        },
        closeDialog(isPrint) {
            this.dialogVisible = false;
            if (isPrint) {
                this.tableData.forEach(item => {
                    if (item.EntpCusPOId == this.idList[0].id) {
                        item.PrintedCount += 1;
                        return;
                    }
                });
                this.$refs.multipleTable.clearSelection();
            }
        },
        // 打印预览
        printPreview(canPrintSave) {
            if (!this.isDefaultSet) {
                let LODOP = this.$lodop.getLodop();
                if (!LODOP) return;
            }
            if (this.idList.length != 1) {
                this.$util.warningMsg('请选择一张采购单打印');
                return;
            }
            if (this.multipleSelection[0].StateName == '已取消') {
                this.$util.warningMsg('不能打印已取消的采购单');
                return;
            }
            this.canPrint = true;
            if (this.multipleSelection[0].StateName == '未提交') {
                if (canPrintSave) {
                    //可以预览但是不能打印
                    this.canPrint = false;
                } else {
                    this.$util.warningMsg('不能打印未提交的采购单');
                    return;
                }
            }

            // if (this.multipleSelection[0].WarehouseType == 1) {
            //     this.$util.warningMsg('不能打印指定前置仓入仓的采购单');
            //     return;
            // }
            this.dialogVisible = true;
        },
        print() {
            if (this.idList.length != 1) {
                this.$util.warningMsg('请选择一张采购单打印');
                return;
            }
            if (this.multipleSelection[0].StateName == '已取消') {
                this.$util.warningMsg('不能打印已取消的采购单');
                return;
            }
            if (this.multipleSelection[0].StateName == '未提交') {
                this.$util.warningMsg('不能打印未提交的采购单');
                return;
            }
            // if (this.multipleSelection[0].WarehouseType == 1) {
            //     this.$util.warningMsg('不能打印指定前置仓入仓的采购单');
            //     return;
            // }
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            let that = this;
            if (LODOP) {
                this.$refs.printDom.init(true);
            } else {
                this.$util.warningMsg('打印异常，请刷新后重新操作');
            }
        },
        //打印汇总
        printBatch() {
            let that = this;
            if (!that.multipleSelection || that.multipleSelection.length == 0) {
                this.$util.warningMsg('请选择采购');
                return;
            }
            for (let i = 0; i < that.multipleSelection.length; i++) {
                if (that.multipleSelection[i].StateName == '已取消') {
                    this.$util.warningMsg(`采购单【${that.multipleSelection[i].OrderCode}】已取消，不能打印`);
                    return;
                }
            }
            that.dialogPOsVisible = true;
        },
        // 跳转编辑
        add(type, item) {
            let id = item ? item.EntpCusPOId : '';
            this.$router.push(`/purchaseManage/purchaseOrders/edit_v2?type=${type}&id=${id}`);
        },
        addNew(type, item) {
            let id = item ? item.EntpCusPOId : '';
            this.$router.push(`/purchaseManage/purchaseOrders/edit_v3?type=${type}&id=${id}`);
        },
        // 跳转历史配件采购
        history() {
            this.$router.push(`/purchaseManage/purchaseOrders/histories`);
        },
        // 跳转采购计划
        planDetail() {
            this.$router.push(`/purchaseManage/purchaseOrders/planDetail`);
        },
        cancel(row) {
            let that = this;
            that.$confirm('确定要取消该采购单吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$util
                    .axiosPost({
                        url: '/api/EntpPurchaseOrder/CancelEntpPurOrder',
                        data: {
                            EntpCusPOId: row.EntpCusPOId
                        }
                    })
                    .then(res => {
                        if (res.errcode == 0) {
                            that.$util.successMsg('取消成功！');
                            that.getSingleData({ Id: row.EntpCusPOId, IsAdd: false }, true);
                        }
                    });
            });
        },
        // 删除采购
        del(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该采购单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpPurchaseOrder/DelEntpPurOrder',
                            data: {
                                EntpCusPOId: row.EntpCusPOId
                            }
                        })
                        .then(() => {
                            that.$util.successMsg('删除成功！');
                            let idx = that.tableData.findIndex(f => f.EntpCusPOId === row.EntpCusPOId);
                            that.tableData.splice(idx, 1);

                            that.tableDataLength -= 1;
                        });
                }
            });
        },
        resetSearch() {
            this.searchData = {
                Keyword: '',
                State: '',
                OrderCode: '',
                StartDate: '',
                UStartDate: '',
                UEndDate: '',
                EndDate: '',
                CStartDate: '',
                CEndDate: '',
                WStartDate: '',
                WEndDate: '',
                SortProp: '',
                SortType: '',
                WarehouseId: '',
                CusSources: '',
                OrgId: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.dateTimes1 = [];
            this.dateTimes2 = [];
            this.dateTimes3 = [];
            this.datetimes4 = [];
            this.searchSupplier('');
            this.$refs.multipleTable.clearSelection();
        },
        getTableData() {
            if (!this.isStopReq) {
                this.loading = true;
                this.isStopReq = true;
                this.$util
                    .axiosGet({
                        url: '/api/EntpPurchaseOrder/GetEntpPurOrderList',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (!data) data = [];
                        if (data.DataList) this.tableData = data.DataList;
                        else this.tableData = [];
                        if (this.searchData.page == 1) {
                            this.tableDataLength = res.count;
                            this.summaryStr = data.SummaryStr;
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                        this.isStopReq = false;
                    });
            }
        },
        handleSearch() {
            this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event) {
                let id = event.EntpCusPOId;
                this.$router.push(`/purchaseManage/purchaseOrders/check?id=${id}`);
            }
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.SIdList.length <= 1) that.getSIdList();
            }
        },
        //当支付状态下拉框出现时触发
        payVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.payWayList.length == 0) that.getPay();
            }
        },
        gotoImportPage() {
            this.$router.push('/purchaseManage/purchaseOrders/importOrdersExcel');
        },
        gotoImportCreatePage() {
            this.$router.push('/purchaseManage/purchaseOrders/importToCreateOrder');
        },
        opRecords(item) {
            let id = item ? item.EntpCusPOId : '';
            if (id) {
                this.OrderId = id;
                this.OrderLifesVisible = true;
            } else {
                this.$util.warningMsg('订单数据异常，请刷新后重新操作');
            }
        },
        closeOrderLifesDialog() {
            this.OrderLifesVisible = false;
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        showSearchDialog() {
            if (this.SIdList.length <= 1) this.getSIdList();
            this.dialogSearchVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog_N() {
            this.dialogSearchVisible = false;
            this.isStartSearch = false;
            // this.resetSearch();
        },
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.UStartDate = val[0];
                this.searchData.UEndDate = val[1];
            } else {
                this.searchData.UStartDate = '';
                this.searchData.UEndDate = '';
            }
        },
        onDate3TimeSelect(val) {
            if (val != null) {
                this.searchData.CStartDate = val[0];
                this.searchData.CEndDate = val[1];
            } else {
                this.searchData.CStartDate = '';
                this.searchData.CEndDate = '';
            }
        },
        onDate4TimeSelect(val) {
            if (val != null) {
                this.searchData.WStartDate = val[0];
                this.searchData.WEndDate = val[1];
            } else {
                this.searchData.WStartDate = '';
                this.searchData.WEndDate = '';
            }
        },
        uploadSuccess(res) {
            if (res.errcode == 0) {
                this.$util.setLocalStorage('cyPurOrderData', res.data);
                this.$router.push('/purchaseManage/purchaseOrders/importCYOrders');
                this.upLoading = false;
            } else {
                this.$util.errorMsg(res.errmsg);
                this.upLoading = false;
            }
        },
        uploadErr(error) {
            this.upLoading = false;
            const result = JSON.parse(error.message);
            this.$util.errorMsg(result.message);
        },
        beforeUpload(file) {
            this.$util.clearLocalStorage('cyPurOrderData');
            this.upLoading = true;
        },
        addCombineLock(item) {
            let that = this;
            if (item.EntpCusPOId) {
                that.$confirm('您确定要将【' + item.OrderCode + '】锁定吗？锁定后，将无法合并商品到该采购单', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '我再考虑考虑',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.$util
                            .axiosPost({
                                url: `/api/EntpPurchaseOrder/AddCombineLock?EntpCusPOId=` + item.EntpCusPOId
                            })
                            .then(res => {
                                that.$util.successMsg(res.errmsg);
                                let sIdx = that.tableData.findIndex(f => f.EntpCusPOId === item.EntpCusPOId);
                                if (sIdx > -1) {
                                    that.tableData[sIdx].IsLock = true;
                                }
                            })
                            .finally(() => {});
                    })
                    .catch(() => {});
            }
        },
        cancleCombineLock(item) {
            let that = this;
            if (item.EntpCusPOId) {
                that.$confirm('您确定要取消采购单【' + item.OrderCode + '】的锁定吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '我再考虑考虑',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.$util
                            .axiosPost({
                                url: `/api/EntpPurchaseOrder/CancelCombineLock?EntpCusPOId=` + item.EntpCusPOId
                            })
                            .then(res => {
                                that.$util.successMsg(res.errmsg);
                                let sIdx = that.tableData.findIndex(f => f.EntpCusPOId === item.EntpCusPOId);
                                if (sIdx > -1) {
                                    that.tableData[sIdx].IsLock = false;
                                }
                            })
                            .finally(() => {});
                    })
                    .catch(() => {});
            }
        },
        addToInten(item) {
            let that = this;
            if (item.EntpCusPOId) {
                that.$confirm('您确定要将【' + item.OrderCode + '】并入在订吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '我再考虑考虑',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.$util
                            .axiosPost({
                                url: `/api/EntpPurchaseOrder/AddToIntenDatas?EntpCusPOId=` + item.EntpCusPOId
                            })
                            .then(res => {
                                that.$util.successMsg(res.errmsg);
                                let sIdx = that.tableData.findIndex(f => f.EntpCusPOId === item.EntpCusPOId);
                                if (sIdx > -1) {
                                    that.tableData[sIdx].IsTranInten = true;
                                }
                            })
                            .finally(() => {});
                    })
                    .catch(() => {});
            }
        },
        cancleToInten(item) {
            let that = this;
            if (item.EntpCusPOId) {
                that.$confirm('您确定要取消采购单【' + item.OrderCode + '】的在订数据吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '我再考虑考虑',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.$util
                            .axiosPost({
                                url: `/api/EntpPurchaseOrder/CancelToIntenDatas?EntpCusPOId=` + item.EntpCusPOId
                            })
                            .then(res => {
                                that.$util.successMsg(res.errmsg);
                                let sIdx = that.tableData.findIndex(f => f.EntpCusPOId === item.EntpCusPOId);
                                if (sIdx > -1) {
                                    that.tableData[sIdx].IsTranInten = false;
                                }
                            })
                            .finally(() => {});
                    })
                    .catch(() => {});
            }
        },
        wHVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length == 0) {
                    this.$util.getWarehouse(1).then(data => {
                        this.warehouseList = data;
                    });
                }
            }
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.orgSearchData.length == 0)
                    that.$util.getParentOrgs().then(data => {
                        that.orgSearchData = data;
                    });
            }
        },
        cusSourceVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.cusSourceList.length == 0) {
                    that.$util.getPurOrderSetSources().then(data => {
                        if (data) {
                            that.cusSourceList = [...data, { Value: '-1', Text: '其他' }];
                        } else {
                            that.cusSourceList = [{ Value: '-1', Text: '其他' }];
                        }
                    });
                }
            }
        },
        // 回传数据到第三方
        callbackData(row) {
            let that = this;
            that.$util
                .axiosPost({
                    url: '/api/EntpPurchaseOrder/CallbackData?EntpCusPOId=' + row.EntpCusPOId,
                    data: {
                        EntpCusPOId: row.EntpCusPOId
                    }
                })
                .then(res => {
                    that.$util.successMsg(res.errmsg);
                });
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (
                    column.property == 'WarehouseName' ||
                    column.property == 'SName' ||
                    column.property == 'PayTypeName' ||
                    column.property == 'UpdateTime' ||
                    column.property == 'Remark' ||
                    column.property == 'CreateTime' ||
                    column.property == 'ConfirmTime' ||
                    column.property == 'WHFinishTime'
                ) {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    let strL = sums[index] + '';
                    if (strL.indexOf('.') > -1) {
                        let str = strL.split('.')[1];
                        if (str.length > 2) {
                            sums[index] = sums[index].toFixed(2);
                        }
                    }
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        finishCallBack() {
            let that = this;
            if (!that.multipleSelection || that.multipleSelection.length == 0) {
                this.$util.warningMsg('请选择采购');
                return;
            } else if (that.multipleSelection.length > 1) {
                this.$util.warningMsg('只能操作一张订单');
                return;
            }
            let EntpCusPOId = that.multipleSelection[0].EntpCusPOId;
            that.$confirm('是否需要回传', '提示', {
                confirmButtonText: '结单并回传',
                cancelButtonText: '只结单',
                type: 'warning',
                distinguishCancelAndClose: true,
                closeOnClickModal: false
            })
                .then(status => {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpPurchaseOrder/FinishCallback?EntpCusPOId=${EntpCusPOId}&IsCallBack=${status == 'confirm'}`
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg(res.errmsg);
                                that.getTableData();
                            }
                        });
                })
                .catch(status => {
                    if (status == 'cancel') {
                        that.$util
                            .axiosPost({
                                url: `/api/EntpPurchaseOrder/FinishCallback?EntpCusPOId=${EntpCusPOId}&IsCallBack=${status == 'confirm'}`
                            })
                            .then(res => {
                                if (res.errcode == 0) {
                                    that.$util.successMsg(res.errmsg);
                                    that.getTableData();
                                }
                            });
                    }
                });
        },
        getSingleData(param, isUpdate) {
            let that = this;
            that.$store.commit('updateOrderList', { Id: '', IsAdd: false });
            if (param.IsAdd && this.searchData.page == 1) {
                //获取单条数据，插入就行，删掉最后一条
                that.$util
                    .axiosGet({
                        url: '/api/EntpPurchaseOrder/GetSigleOrderData',
                        data: {
                            Id: param.Id,
                            IsUpdate: isUpdate
                        }
                    })
                    .then(res => {
                        if (res.data) {
                            if (that.tableData.length == that.searchData.limit) that.tableData.splice(-1, 1);
                            that.tableData.unshift(res.data.DataList[0]);

                            that.tableDataLength += 1;

                            if (isUpdate) that.summaryStr = res.data.SummaryStr;
                        }
                    })
                    .catch(() => {});
            } else {
                //获取单条，更新
                that.$util
                    .axiosGet({
                        url: '/api/EntpPurchaseOrder/GetSigleOrderData',
                        data: {
                            Id: param.Id,
                            IsUpdate: isUpdate
                        }
                    })
                    .then(res => {
                        if (res.data) {
                            let idx = that.tableData.findIndex(f => f.EntpCusPOId === param.Id);
                            that.tableData.splice(idx, 1, res.data.DataList[0]);

                            if (isUpdate) that.summaryStr = res.data.SummaryStr;
                        }
                    })
                    .catch(() => {});
            }
        }
    }
};
</script>
<style lang="less" scoped>
#search-order-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
<style lang="less">
.sales-order-table {
    .el-table__row {
        td:nth-child(2) {
            .cell {
                overflow: visible;
            }
        }
    }
}
.in-active {
    color: #ff0097;
}
.pay-active {
    color: #0dbdae;
}
</style>
